import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OrderLoad } from '@ordersnproducts/modules/order-builder/modules/multiple-order-summary/models/orderSummary.model';
import { OrderBuilderFeatureState } from '@ordersnproducts/modules/order-builder/reducers';
import { MultipleOrderConfirmationActions, MultipleOrderConfirmationActionTypes } from '../actions/order.actions';
import { OrdersConfirmation } from '../models/orderConfirmation.model';

export interface MltOrdersConfirmState {
  loading: boolean;
  orders: MltOrdersConfirm[];
  batchId: number;
}

export interface MltOrdersConfirm {
  order: OrdersConfirmation;
  items: OrderLoad[];
}

export const initialState: MltOrdersConfirmState = {
  loading: false,
  orders: [],
  batchId: undefined,
};

export const orderConfirmationKey = 'orderBuilder';
export const getOrderConfirmationState = createFeatureSelector<OrderBuilderFeatureState>(orderConfirmationKey);
export const getOrderConfirmationOrderData = createSelector(
  getOrderConfirmationState,
  state => state.multipleOrderConfirmationPage.mltOrdersConfirmStateState,
);

export function orderReducer(state = initialState, action: MultipleOrderConfirmationActions): MltOrdersConfirmState {
  switch (action.type) {
    case MultipleOrderConfirmationActionTypes.RESET: {
      return {
        loading: false,
        orders: [],
        batchId: undefined,
      };
    }
    case MultipleOrderConfirmationActionTypes.REQUEST: {
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    case MultipleOrderConfirmationActionTypes.REQUEST_COMPLETE: {
      state.orders = action.payload;
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    case MultipleOrderConfirmationActionTypes.SET_ORDER_CODE: {
      const order = state.orders.find(item => item.order.orderId === action.payload.orderId);
      if (order) {
        order.order.orderCode = action.payload.orderCode;
        order.order.errorMessage = action.payload.errorMessage;
        order.order.orderError = action.payload.orderError;
        order.order.processed = true;
      }
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    case MultipleOrderConfirmationActionTypes.SET_ORDER_CODES: {
      action.payload.forEach(comOrder => {
        const order = state.orders.find(item => item.order.orderId === comOrder.orderId);
        if (order) {
          order.order.orderCode = comOrder.orderCode;
          order.order.errorMessage = comOrder.errorMessage;
          order.order.orderError = comOrder.orderError;
          order.order.processed = true;
          order.order.hasSpecialBlock = comOrder.hasSpecialBlock;
          order.order.status = comOrder.status;
        }
      });
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    case MultipleOrderConfirmationActionTypes.SET_BATCH_ID: {
      state.batchId = action.payload;
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    case MultipleOrderConfirmationActionTypes.SET_ORDER_ERRORS: {
      action.payload.forEach(comOrder => {
        const order = state.orders.find(item => item.order.orderId === comOrder.orderId);
        if (order) {
          order.order.orderCode = comOrder.orderCode;
          order.order.errorMessage = comOrder.errorMessage;
          order.order.orderError = comOrder.orderError;
          order.order.processed = true;
          order.order.hasSpecialBlock = comOrder.hasSpecialBlock;
        }
      });
      return {
        ...state,
      } as MltOrdersConfirmState;
    }
    default: {
      return state;
    }
  }
}
